import type { AdminLessonListVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import type { LessonPaginationParams } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveLessons = createApiThunk<PaginatedResult<AdminLessonListVM>, LessonPaginationParams>(
  "lessons/adminRetrieveLessons",
  async ({ page = 1, pageSize = 50, sortBy, sortOrder, filters }, { extra: { adminRepository } }) => {
    return adminRepository!.listLessons({
      page,
      pageSize,
      sortBy,
      sortOrder,
      filters,
    });
  },
);
